export default "__VITE_ASSET__Cf2$a9Bi__"